var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_171_150)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_171_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.749 2.12115C9.08013 2.12115 0.429474 10.1349 0.429474 20.0101C0.429474 27.9148 5.96659 34.6125 13.6426 36.98C13.7503 37.0011 13.8602 37.0116 13.9704 37.0111C14.6862 37.0111 14.9622 36.5361 14.9622 36.1233C14.9622 35.695 14.945 34.5735 14.9364 33.0782C14.2973 33.2135 13.6435 33.284 12.9872 33.2885C9.26988 33.2885 8.42465 30.6795 8.42465 30.6795C7.54492 28.6157 6.27708 28.0628 6.27708 28.0628C4.59525 26.9958 6.26845 26.9647 6.39783 26.9647H6.40645C8.34703 27.1205 9.36475 28.8182 9.36475 28.8182C10.3307 30.3447 11.6244 30.773 12.7802 30.773C13.5444 30.7592 14.2967 30.6 14.9881 30.3057C15.1606 29.1531 15.6608 28.3665 16.2128 27.9148C11.9263 27.4631 7.41555 25.9289 7.41555 19.0755C7.41555 17.1207 8.16591 15.5242 9.39925 14.2781C9.20088 13.8264 8.53677 12.0041 9.589 9.54306C9.73014 9.51257 9.8752 9.49947 10.0202 9.50412C10.7188 9.50412 12.2972 9.74555 14.9019 11.381C18.0668 10.5814 21.414 10.5814 24.5789 11.381C27.1836 9.74555 28.7619 9.50412 29.4605 9.50412C29.6055 9.49947 29.7506 9.51257 29.8917 9.54306C30.944 12.0041 30.2799 13.8264 30.0815 14.2781C31.3148 15.532 32.0652 17.1285 32.0652 19.0755C32.0652 25.9445 27.5458 27.4553 23.242 27.8992C23.932 28.4522 24.553 29.5425 24.553 31.2091C24.553 33.6 24.5271 35.5314 24.5271 36.1155C24.5271 36.5361 24.7945 37.0111 25.5103 37.0111C25.6262 37.0116 25.7419 37.0012 25.8553 36.98C33.54 34.6125 39.0685 27.907 39.0685 20.0101C39.0685 10.1349 30.4179 2.12115 19.749 2.12115Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_171_150",
    x: 0.429474,
    y: 2.12115,
    width: 38.639,
    height: 38.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_171_150"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_171_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.6727,
    height: 36.722,
    fill: "white",
    transform: "translate(0.429474)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.1a0bc2bf69202f97d8baa3422367d9f3.svg";
export { ForwardRef as ReactComponent };